import base from "./base";
import appearance from "./appearance";
import visibility from "./visibility";

export default `
${appearance}
${base}
${visibility}
`;
